import { SERVER_URL } from "./config";

const groupNames = ["group-1"];

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

const mrStatementDataObject = {
  total_amount: "",
  total_pkgs: "",
  total_weight: "",
  total_bilties: "",
  total_pf: ""
};

const gurumrStatementGroupInfo = {
  "group-1": [
    {
      label: "Total Bilties",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_bilties",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Pkgs",
      className: "form-row-m",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_pkgs",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Weight",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_weight",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Amount",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total PF",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_pf",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
};

const ashapuramrStatementGroupInfo = {
  "group-1": [
    {
      label: "Total Bilties",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_bilties",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Pkgs",
      className: "form-row-m",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_pkgs",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Weight",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_weight",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Amount",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Hamali",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_hamali",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total DD",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_dd",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
};
const bgtcmrStatementGroupInfo = {
  "group-1": [
    {
      label: "Total Bilties",
      className: "form-row-m",
      labelClassName: "form-label-w-bgtc",
      inputClassName: "form-input-bgtc",
      name: "total_bilties",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Pkgs",
      className: "form-row-m",
      labelClassName: "form-label-w-bgtc",
      inputClassName: "form-input-bgtc",
      name: "total_pkgs",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Weight",
      className: "form-row-",
      labelClassName: "form-label-w-bgtc",
      inputClassName: "form-input-bgtc",
      name: "total_weight",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Amount",
      className: "form-row-m",
      labelClassName: "form-label-w-bgtc",
      inputClassName: "form-input-bgtc",
      name: "total_amount",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
};

const defaultmrStatementGroupInfo = {
  "group-1": [
    {
      label: "Total Bilties",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_bilties",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Pkgs",
      className: "form-row-m",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_pkgs",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Weight",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_weight",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
    {
      label: "Total Amount",
      className: "form-row-m",
      labelClassName: "form-label-w",
      inputClassName: "form-input",
      name: "total_amount",
      type: "text",
      placeHolder: "1234",
      idClearanceNeeded: "item_id",
      onChangeIgnoreClearance: ["description"],
    },
  ],
};

const getmrStatementGroupInfoBasedOnClient = ()=> {
  if (process.env.REACT_APP_CLIENT == "guru"){
    return gurumrStatementGroupInfo
  }
  if (process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam"){
    return ashapuramrStatementGroupInfo
  }
  if (["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT)){
    return bgtcmrStatementGroupInfo
  }
  else {
    return defaultmrStatementGroupInfo
  }
}

var mrStatementGroupInfo = getmrStatementGroupInfoBasedOnClient()
export {
  groupNames,
  mrStatementGroupInfo,
  mrStatementDataObject,
};